var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"roster-header-row",attrs:{"aria-hidden":"true"}},[_c('span',{staticClass:"roster-header-worker"},[_vm._v("Worker")]),_c('span',{staticClass:"roster-header-status"},[_vm._v("Status")]),_c('span',{staticClass:"roster-header-hours"},[_vm._v("Total Hours")]),_c('span',{staticClass:"roster-header-actions"})])
}]

export { render, staticRenderFns }